import { http } from "services/http";

import type { UsersLogRequest, UsersLogResponse } from "models/users-action.model";
import type {
  UserCreateRequest,
  UserCreateResponse,
  UserDetails,
  UserIdRequest,
  UserLimitsRequest,
  UserLimitsResponse,
  UserPartnersRequest,
  UserPartnersResponse,
  UserRecord,
  UsersListRequest,
  UsersListResponse,
  UserUpdateRequest,
  UserVerifyResponse,
  UserWalletsRequest,
} from "models/users.model";

export const usersApi = {
  getUsersData: (data?: UsersListRequest) =>
    http.quiet().post<UsersListResponse>("/api/users", data ? { ...data } : null),
  getUserData: (data: UserIdRequest) =>
    http.quiet().post<UserDetails>("/api/users/get", { ...data }),
  getUserPartners: (data: UserPartnersRequest) =>
    http.quiet().post<UserPartnersResponse>("/api/users/get-partners", { ...data }),
  updateUser: (data: UserUpdateRequest) =>
    http.quiet().post<UserRecord>("/api/users/update", { ...data }),
  updateUserDepositLimits: (data: UserLimitsRequest) =>
    http.quiet().post<UserLimitsResponse>("/api/users/update-limits", { ...data }),
  updateUserWallets: (data: UserWalletsRequest) =>
    http.quiet().post("/api/users/update-wallets", { ...data }),
  singninAsUser: (data: UserIdRequest) =>
    http.quiet().post<UserVerifyResponse>("/api/users/verify", { ...data }),
  createUser: (data: UserCreateRequest) =>
    http.quiet().post<UserCreateResponse>("/api/users/create", { ...data }),
  getActionsData: (data?: UsersLogRequest) =>
    http.quiet().get<UsersLogResponse>("/api/users-log", data ? { ...data } : null),
};
